import { getContainerStates } from 'ducks/container-states-list/operators';
import { getCpuArchitectures } from 'ducks/cpu-architectures-list/operators';
import { getFileStates } from 'ducks/file-states-list/operators';
import { getIntervals } from 'ducks/intervals-list/operators';
import { getJobStates } from 'ducks/job-states-list/operators';
import { getLocationGroups } from 'ducks/location-groups-list/operators';
import { getLocations } from 'ducks/locations-list/operators';
import { getParameterDirections } from 'ducks/parameter-directions-list/operators';
import { getParameterMethodStates } from 'ducks/parameter-methods-list/operators';
import { getReferenceTypes } from 'ducks/reference-types-list/operators';
import { getResultMethods } from 'ducks/result-methods-list/operators';
import { updateSettings } from 'ducks/settings/slices';
import { getSystemParameters } from 'ducks/system-parameters-list/operators';
import { store } from 'store';

export const getLookups = async () => {
  store.dispatch(updateSettings({ loading: true }));

  return await Promise.all([
    store.dispatch(getSystemParameters()),
    store.dispatch(getParameterDirections()),
    store.dispatch(getJobStates()),
    store.dispatch(getIntervals()),
    store.dispatch(getFileStates()),
    store.dispatch(getCpuArchitectures()),
    store.dispatch(getParameterMethodStates()),
    store.dispatch(getResultMethods()),
    store.dispatch(getContainerStates()),
    store.dispatch(getLocations()),
    store.dispatch(getLocationGroups()),
    store.dispatch(getReferenceTypes()),
  ]);
};
